import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import 'prop-types';
import ButtonPrimary from './ButtonPrimary.js';
import ButtonSecondary from './ButtonSecondary.js';
import ButtonTertiary from './ButtonTertiary.js';
import ButtonBase from './Base/ButtonBase.js';
import ButtonPrimaryDark from './ButtonPrimaryDark.js';
import ButtonSecondaryDark from './ButtonSecondaryDark.js';
import ButtonTertiaryDark from './ButtonTertiaryDark.js';
import ButtonChevron from './ButtonChevron.js';
import ButtonCobrand from './ButtonCobrand.js';
import ButtonLoading from './Base/ButtonLoading.js';
import ButtonFloatingChat from './ButtonFloatingChat.js';
import ButtonFloatingScroll from './ButtonFloatingScroll.js';

// eslint-disable-next-line complexity

var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var styleType = props.styleType,
      otherProps = _objectWithoutProperties(props, ["styleType"]);

  if (styleType.includes('cobrand')) {
    return jsx(ButtonCobrand, _extends({}, otherProps, {
      ref: ref,
      cobrand: styleType.replace('cobrand', '')
    }));
  }

  switch (styleType) {
    case 'primary':
      return jsx(ButtonPrimary, _extends({}, otherProps, {
        ref: ref
      }));

    case 'secondary':
      return jsx(ButtonSecondary, _extends({}, otherProps, {
        ref: ref
      }));

    case 'tertiary':
      return jsx(ButtonTertiary, _extends({}, otherProps, {
        ref: ref
      }));

    case 'white':
      return jsx(ButtonPrimaryDark, _extends({}, otherProps, {
        ref: ref
      }));

    case 'whiteSecondary':
      return jsx(ButtonSecondaryDark, _extends({}, otherProps, {
        ref: ref
      }));

    case 'whiteTertiary':
      return jsx(ButtonTertiaryDark, _extends({}, otherProps, {
        ref: ref
      }));

    case 'contextual':
      return jsx(ButtonPrimaryDark, _extends({}, otherProps, {
        ref: ref
      }));

    case 'chevron':
      return jsx(ButtonChevron, _extends({}, otherProps, {
        ref: ref
      }));

    case 'floatingChat':
      return jsx(ButtonFloatingChat, _extends({}, otherProps, {
        ref: ref
      }));

    case 'floatingScroll':
      return jsx(ButtonFloatingScroll, _extends({}, otherProps, {
        ref: ref
      }));

    default:
      {
        otherProps.loading;
            var otherPropsMinusLoading = _objectWithoutProperties(otherProps, ["loading"]);

        return otherProps.loading ? jsx(ButtonLoading, _extends({}, otherPropsMinusLoading, {
          ref: ref
        })) : jsx(ButtonBase, _extends({}, otherPropsMinusLoading, {
          ref: ref
        }));
      }
  }
});
Button.displayName = 'Button';
Button.defaultProps = {
  children: '',
  loading: false,
  size: 'md',
  styleType: '',
  type: 'button',
  theme: {}
};

export default Button;
